import { Route } from '@angular/router';

export const tariffsRoute: Route[] = [
  {
    path: '',
    redirectTo: 'list',
    pathMatch: 'full',
  },
  {
    path: 'list',
    loadComponent: () => import('./pages').then(p => p.TariffListComponent),
    title: 'UIMS - Tariffs',
  },
  {
    path: 'create',
    loadComponent: () => import('./pages').then(p => p.TariffCreateComponent),
    title: 'UIMS - Tariff create',
  },
  {
    path: 'details/:id',
    loadComponent: () => import('./pages').then(p => p.TariffDetailsComponent),
    title: 'UIMS - Tariff Details',
  },
];
